/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EmailReportEntry {
    getFixupPrototypeFunction() { return EmailReportEntry.fixupPrototype; }

    static newInstance(model: Partial<EmailReportEntry>): EmailReportEntry {
        let obj = Object.assign(new EmailReportEntry(), model);
        EmailReportEntry.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EmailReportEntry>): EmailReportEntry {
        if (!model) return null;
        return EmailReportEntry.newInstance(<EmailReportEntry> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EmailReportEntry) {
        if (!obj) return;

        models.EmailReportEntry.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EmailReportEntry): boolean {
        Object.setPrototypeOf(obj, EmailReportEntry.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Email addresses for this report
     */
    email_address: Array<string>;

    /**
     * Whether this report is enabled
     */
    enabled: boolean;

}
